import React, { useContext } from 'react';
import Button from '@src/components/wysiwyg_editor/toolbox/Button';

import image from '@images/wysiwyg_editor/toolbox_icons/photos.svg';
import { WysiwygEditorDispatchContext } from '@src/contexts/wysiwyg/editor';
import useIsLargeScreen from '@src/hooks/useIsLargeScreen';

type TProps = {
  active: boolean;
};

function Photos(props: TProps): React.ReactElement {
  const { toggleToolboxTab } = useContext(WysiwygEditorDispatchContext);
  const isLarge = useIsLargeScreen();

  return (
    <Button
      active={props.active}
      image={image as string}
      style={isLarge ? { borderTop: 'none' } : {}}
      onClick={() => toggleToolboxTab('photos')}
    >
      Photos
    </Button>
  );
}

export default Photos;
